import React, { useState } from 'react';
import { useChangePasswordMutation } from '../services/auth/authApi';

const ChangePasswordModal = ({ isOpen, onClose }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [changePassword, { isLoading }] = useChangePasswordMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!currentPassword || !newPassword) {
      // alert('Please fill in all fields');
      return;
    }

    try {
      const result = await changePassword({
        currentPassword,
        newPassword
      }).unwrap();
      
      // alert('Password changed successfully');
      setCurrentPassword('');
      setNewPassword('');
      onClose();
    } catch (error) {
      // alert(error?.data?.message || 'Failed to change password');
    }
  };

  const handleCancel = () => {
    setCurrentPassword('');
    setNewPassword('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50" onClick={handleCancel}></div>
      <div className="bg-white rounded-lg w-full max-w-lg mx-4 relative z-10">
        {/* Header */}
        <div className="bg-[#1e3a3a] text-white px-6 py-2 flex justify-between items-center rounded-t-lg">
          <h2 className="text-l font-semibold">Change Password</h2>
          <button 
            onClick={handleCancel}
            className="text-white hover:text-gray-300 text-3xl leading-none"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="p-6">
          <div className="space-y-4">
            {/* Old Password */}
            <div>
              <input
                type="password"
                placeholder="Enter old password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="w-full px-3 py-1 border-1 border-gray-300 rounded text-base placeholder-gray-400 focus:outline-none focus:border-gray-400"
              />
            </div>

            {/* New Password */}
            <div>
              <input
                type="password"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="w-full px-3 py-1 border-1 border-gray-300 rounded text-base placeholder-gray-400 focus:outline-none focus:border-blue-500"
              />
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-4 mt-6">
            <button
              type="button"
              onClick={handleCancel}
              className="bg-[#2c4a4a] text-white px-6 py-2 rounded text-base font-medium hover:bg-[#3a5858] transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="bg-[#3b9ff3] text-white px-6 py-2 rounded text-base font-medium hover:bg-[#2a8fe3] transition-colors disabled:opacity-50"
            >
              {isLoading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;